import { JsonProperty } from '../../../models/utilities/json-property';
import { ShipmentType } from '../enums/_index';
import { AssetType } from '../enums/asset-type';
import { RunningTotal } from '../shared/running-total';
import { ShipmentRead } from '../shipments/shipment-read';

export class AssetReference {

    public type : AssetType = AssetType.Tractor;

    public id : number|undefined = undefined;
    
    public name : string = '';

}

export class DriverReference {
    
    public id : number|undefined = undefined;
    
    public driverId : string = '';
    
    public firstName : string = '';
    
    public lastName : string = '';
    
    public cellPhone : string = '';

    // UI Helper Property
    public fullName : string = '';

}

export class PortOfEntryReference {

    public id : number = 0;

    public name : string = '';

}

export class TruckRead extends ShipmentRead {

    @JsonProperty({ toClass: DriverReference })
    public driver : DriverReference|undefined = new DriverReference();
    
    @JsonProperty({ toClass: AssetReference })
    public tractor : AssetReference|undefined = new AssetReference();
    
    @JsonProperty({ toClass: AssetReference })
    public trailer : AssetReference|undefined = new AssetReference();

    @JsonProperty({ toClass: PortOfEntryReference })
    public portOfEntry : PortOfEntryReference|undefined = new PortOfEntryReference();

    // UI Helpers
    public departureTime    : string = '';
    public returnTime       : string = '';
    public totalTravelTime  : string = '00:00:00';
    public totalDistance    : number = 0;
    public metrics          : RunningTotal = new RunningTotal();
    public isSelected       : boolean = false;
    public tmpClientId      : string = '';
    public isDisabled       : boolean = false;

    constructor() {
        super();
        this.type = ShipmentType.Truck;
    }

}
